export const SET_TOGGLE_MENU = 'SET_TOGGLE_MENU';

export function setToggleMenu(data) {
    return function (dispatch) {
        dispatch({ type: SET_TOGGLE_MENU, toggleMenu: data });
    };
}